var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bussess-content"},[_c('BussinessStep1'),_vm._v(" "),_c('BussinessStep2'),_vm._v(" "),_c('BussinessStep3'),_vm._v(" "),_c('BussinessStep4'),_vm._v(" "),_c('BussinessStep5'),_vm._v(" "),_c('BussinessStep6')],1)}
var staticRenderFns = []

export { render, staticRenderFns }